{
  "endTime": "Краен час",
  "startTime": "Начален час",
  "time": "Време"
}
